import React from 'react';
import profileImg from '../../assets/images/about/profile.png';
import '../../styles/global.css';

function About() {
  return (
    <section id="about">
      <h1 className="section-title">ABOUT</h1>
      <div className="about-content">
        <img className="about-img" src={profileImg} alt="津田千穂の顔写真" />
        <div className="about-info-wrapper">
          <div className="about-info-content">
            <div className="about-name">津田千穂</div>
            <div className="about-text">
            九州工業大学卒業後、IT企業でプログラマーとして1年半システム開発に従事しました。現在は事業会社でwebデザイナーとして働いています。前職の経験を活かし、デザインとエンジニアリングの両面で活躍することを目指しています。好きな言葉は「アイデアいっぱいの人は深刻化しない」です。
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;